/**
 * Sign shared block scripts
 * This file gets shared between the
 * theme and editor.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray('.sign').forEach((sign) => {
	
	const duration = 3500;
	const rotators = sign.querySelectorAll('.sign__rotator');
	
	const applyScrollAni = () => {
		gsap.to(sign, {
			rotate: -10,
			scaleX: 0.9,
			transformOrigin: '73% 88%',
			scrollTrigger: {
				trigger: sign,
				ease: 'linear',
				start: 'top top',
				end: 'bottom top',
				scrub: 1.5,
				toggleActions: 'play reset play reset',
				// /*DEBUG*/markers: true, id: 'sign',
			}
		});
	}

	const applyIntroAni = () => {
		gsap
			.from(sign, {
				rotate: -7,
				y: 10,
				scaleY: 0.8,
				transformOrigin: '73% 88%',
				duration: 1.8,
				delay: 0.25,
				ease: 'power4.out',
			});
	}

	const rotateSign = (cur) => {
		rotators.forEach((el, i) => {
			el.classList.remove('rotated');
			i !== cur ? el.classList.remove('active') : el.classList.add('active');
			setTimeout(() => {
				el.classList.add('rotated');
			}, 200);
		});
	}

	const applyRotateSign = () => {
		if (rotators) {
			const max = rotators.length - 1;
			let cur = 0;
			setInterval(() => {
				cur = cur < max ? ++cur : 0;
				rotateSign(cur)
			}, duration);
		}
	}

	// animate in if at top
	if(0 === window.scrollY){
		applyIntroAni();
		setTimeout(applyScrollAni, 1000);
	// start partially played in if scrolled already (e.g. refresh/back)
	} else {
		applyScrollAni();
	}
	// start the rotations
	rotateSign(0)
	applyRotateSign(0);

});
